import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment, environment as ENV } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient
} from '@angular/common/http';
import {
  MsalInterceptor,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalModule
} from '@azure/msal-angular';
import { NetworkInterceptorService } from './app/services/network-interceptor.service';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import { MessageService, ConfirmationService } from 'primeng/api';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  PublicClientApplication,
  BrowserCacheLocation,
  InteractionType
} from '@azure/msal-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const VerisureTheme = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#fbeaed',
      100: '#f5cfd6',
      200: '#eba0af',
      300: '#e17187',
      400: '#d8435d',
      500: '#ab192d',
      600: '#981727',
      700: '#7f1421',
      800: '#65101a',
      900: '#4c0c14',
      950: '#32080d'
    }
  }
});

// Registering Syncfusion license key
registerLicense(
  'Ngo9BigBOggjGyl/VkV+XU9AclRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTc0VmWXhccHVTRGlcV09yXg=='
);

if (environment.production) {
  enableProdMode();
}

console.log(
  `App version ${environment.appVersion} running on ${environment.env}`
);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      MsalModule.forRoot(
        new PublicClientApplication({
          auth: ENV.msalConfig,
          cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage
          },
          system: {
            loggerOptions: {
              loggerCallback: () => {},
              piiLoggingEnabled: false
            }
          }
        }),
        {
          interactionType: InteractionType.Redirect // MSAL Guard Configuration
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: ENV.msalProtectedResourceMap
        }
      ),
      FormsModule,
      ReactiveFormsModule,
      DynamicDialogModule,
      ConfirmDialogModule,
      ToastModule
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptorService,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DialogService,
    MessageService,
    ConfirmationService,
    providePrimeNG({
      theme: {
        preset: VerisureTheme,
        options: {
          darkModeSelector: false
        }
      }
    }),
    provideAnalytics(() => getAnalytics()),
    provideFirebaseApp(() => initializeApp(ENV.firebaseConfig)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
}).catch((err) => console.error(err));
